import { useTranslation } from 'react-i18next';
import { Link, type LinkProps } from 'react-router';

import { clsx } from '~/styles/utils';

import { Logo } from '../Logo/Logo';
import { useNavigationContext } from './Navigation.context';
import { logoCollapsedStyle, logoLinkStyle, logoStyle } from './Navigation.css';

type Props = LinkProps & {
  label?: string;
  to: LinkProps['to'];
};

export const NavigationLogo = ({ label, to, ...delegated }: Props) => {
  const { t } = useTranslation(['common']);
  const { showLabels } = useNavigationContext();

  const logoLabel = label ?? t('common:sidebar.dashboard');

  return (
    <Link {...delegated} aria-label={logoLabel} className={clsx(logoLinkStyle, delegated.className)} to={to}>
      <Logo className={clsx(logoStyle, !showLabels && logoCollapsedStyle)} variant={showLabels ? 'text' : 'symbol'} />
    </Link>
  );
};
